<template>
	<main class="marketing-calendar">
		<router-view></router-view>
	</main>
</template>

<script>
export default {
	name: 'MarketingCalendarHome',
};
</script>

<style lang="scss"></style>
